import React from "react";
import { getCategoryList } from "../../../../react-reduxs/slices/categories/category_slice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../../react-reduxs/configure_store";
import {
  categoryIdChange,
  getProductSelectedCategoryId,
} from "../../../../react-reduxs/slices/products/product_slice";
import { ApiUrl } from "../../../../consts/api";
import { AllergyDisclaimerDialog } from "../AllergyDisclaimerDialog";

const Template4Category = () => {
  const categoryList = useSelector(getCategoryList);
  const dispatch: AppDispatch = useDispatch();
  const selectCategoryId = useSelector(getProductSelectedCategoryId);
  return (
    <div className="t4-category-container">
      <AllergyDisclaimerDialog />
      {[...categoryList]
        .sort((a, b) => a.index - b.index)
        .map((x) => (
          <div
            key={x.id}
            onClick={() => dispatch(categoryIdChange(x.id))}
            className={`t4-category-card ${selectCategoryId === x.id ? "active-category" : ""}`}
          >
            <div className="category-image-wrapper">
              <img
                src={x.photo ? `${ApiUrl}/${x.photo}` : "/images/category.png"}
                alt={x.name}
              />
            </div>
            <div className="category-info">
              <span className="category-title">{x.name}</span>
            </div>
          </div>
        ))}
    </div>
  );
};

export default Template4Category;
